import { ComponentPropsWithoutRef } from 'react';

export const Close = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7782 5.63602L18.364 4.22181L12 10.5858L5.63604 4.22181L4.22183 5.63602L10.5858 12L4.22183 18.3639L5.63604 19.7782L12 13.4142L18.364 19.7782L19.7782 18.3639L13.4142 12L19.7782 5.63602Z"
      fill="currentColor"
    />
  </svg>
);
